import { walletStorageKeys } from '../constants/walletStorageKeys.js';

// WALLET MANAGER TODO: should the default for keys be walletStorageKeys.
function buildStorageValues(_ref) {
  let {
    keys = walletStorageKeys,
    payload
  } = _ref;
  const storageValues = keys.reduce((acc, key) => {
    const {
      downPayment,
      downPaymentPercent,
      budget,
      monthlyBudget
    } = payload;
    // There are valid cases where downPayment, downPaymentPercent, budget, or monthlyBudget should be null, other wallet values should not be null.
    const downPaymentIsNull = key === 'downPayment' && downPayment === null;
    const downPaymentPercentIsNull = key === 'downPaymentPercent' && downPaymentPercent === null;
    const budgetIsNull = key === 'budget' && budget === null;
    const monthlyBudgetIsNull = key === 'monthlyBudget' && monthlyBudget === null;
    if (downPaymentIsNull || downPaymentPercentIsNull || budgetIsNull || monthlyBudgetIsNull || payload[key] != null) {
      acc[key] = payload[key];
    }
    return acc;
  }, {});
  return storageValues;
}
export { buildStorageValues as default };
